import React, { useContext, useEffect, useRef, useState } from "react";
import {BrowserView, isMobile, MobileView} from 'react-device-detect';
import Authentification from "../user/login/Authentification";
import { useTranslation } from 'react-i18next';
import { AppContext, UserContext } from "../../AppContextProvider";
import { useNavigate } from "react-router-dom";
import { useFetch } from "../api/FetchApiData";
import { MediaUrl } from "../utils/media/Media";
import Popup from "reactjs-popup";
import { useWindowHeight } from "@react-hook/window-size";
import { Notifications } from "./Notifications";
import logo from '../icons/djamnazi.webp'; 
import help from '../icons/help.webp';
import apropos from '../icons/apropos.webp';
import panierIcon from '../icons/panier.webp';
import searchBarIcon from '../icons/searchbar_gray.webp';
import ordersIcon from '../icons/orders.webp';
import chariotIcon from '../icons/chariot.webp';
import storeIcon from '../icons/store.webp';
import deliveryIcon from '../icons/delivry.webp';
import cashIcon from '../icons/cash.webp';
import lang_icon from './icons/lang.webp';
import logoutIcon from '../icons/logout.webp';
import removeIcon from '../icons/remove.webp';
import historyIcon from '../icons/history.webp';
import notificationIcon from '../icons/notification.webp';
import logout_icon from './icons/logout.webp';
import profil_icon from './icons/infoprofil.webp';
import orders_icon from '../icons/history.webp';
import messages_icon from '../icons/chat_mobile.webp';
import sales_icon from '../icons/orders.webp';
import { VitrineContext } from "../vitrines/VitrineContext";
import { SettingsMenu } from "./Footer";
import money_icon from './icons/money.webp';
import project_icon from './icons/project.webp';
import gift_icon from '../icons/gift.webp';



export default function Navigation(props)
{
    const [AppState,setAppState] = useContext(AppContext);
    const [UserState,setUserState] = useContext(UserContext);
    const [vitrines,setVitrines] = useContext(VitrineContext);
    const InputSearch = useRef('');
    const screenHeight = useWindowHeight();
    const { t } = useTranslation();
    const navigator = useNavigate();
    const fetchData = useFetch();

    useEffect(()=>
        {
            if (isMobile)
                import('./mobile_navigation.css').then(() => {});
            else
                import('./navigation.css').then(() => {});

            let _panier = localStorage.getItem('panier');
            if(!!_panier && !UserState.auth)
            {
                _panier = JSON.parse(_panier);
                setUserState({...UserState,panier:_panier});
            }
            console.log('Navigation useEffect');
            fetchData.Authenticate(UserState,setUserState);
            const AppTimer  = setInterval(()=>{fetchData.Authenticate(UserState,setUserState);},60000);
            return ()=>clearInterval(AppTimer);
            
    },[])
    
    useEffect(()=>{
        if(!UserState.auth)
        {
          localStorage.setItem('panier',JSON.stringify(UserState.panier));
        }
    },[UserState.panier])
      

    /*
    useEffect(()=>
    {
        //console.log('UserState changed in Navigation : ',UserState);
        if(!UserState.auth && UserState.panier.articles.length>0)
        {sessionStorage.setItem('panier',JSON.stringify(UserState.panier));}
    },[UserState])
    */

    const LogOut = ()=>
    {
        fetchData.LogOut(UserState,setUserState);
    }

    const BrowserUserPanier=()=>
    {
        const FormatText=(text)=>
        {
            try{
            if(text.length < 46)
                return text;
            else
                return text.substring(0,46)+'...';
            }
            catch{return '';}
        }

        const showpanier = ()=>
        {
            if(UserState.panier.articles.length>0)
            {
                return(
                    <div style={{overflowY:'scroll',maxHeight:'25vh',border:'1px solid lightgray',padding:'5px',borderRadius:'5px',marginBottom:'5px'}}>
                        {UserState.panier.articles.map((a,index)=>{
                            let imgsrc = null;
                            if(!!a.article.image)
                                imgsrc = MediaUrl(a.article.image);
                            return(
                                <li key={index} style={{borderRadius:'5px',textAlign:'left',fontSize:'x-small',padding:'5px'}} onClick={e=>{setAppState({...AppState,page:<Authentification />})}} className="subControls-li">
                                    <img src={imgsrc} style={{verticalAlign:'middle',width:'40px',borderRadius:'5px',marginRight:'10px',display:'inline-block'}} />
                                    <div style={{display:'inline-block',verticalAlign:'middle'}}>
                                        <label style={{verticalAlign:'middle',display:'block'}}>{FormatText(a.article.title)}</label>
                                        <span style={{color:'darkgray',fontSize:'x-small',marginLeft:'20px'}}>{t('produit.reference')} : {a.article.id}</span><span style={{color:'darkgray',marginLeft:'20px'}}>{t('produit.quantite')} : {a.quantity}</span>
                                    </div>
                                </li>);
                        })}
                    </div>
                );
            }
            else
            {
                return(                    
                <ul className="SubControls-ul">
                    <li style={{border:'1px solid lightgray',position:'relative',borderRadius:'10px',height:'25px',color:'gray',textAlign:'center',paddingTop:'10px'}} onClick={e=>{setAppState({...AppState,page:<Authentification ConForm={true} />})}}>
                        {t('navigation.aucun-article')}
                    </li>
                </ul>)
            }
        }

        if(UserState.auth)
        {
            return(
                <div className="SubControls" style={{width:'400px'}}>
                    <fieldset id="SubControlsFieldSet">
                        <legend className="triangle"></legend>
                        <ul className="SubControls-ul">
                            {showpanier()}
                            <li style={{marginBottom:'5px',textAlign:'center',border:'none',borderRadius:'5px',paddingLeft:'0px'}} className="subControls-li">
                                { /*
                                    <button onClick={e=>{navigator('/user/conversations/')}} style={{position:'relative',padding:'5px',width:'18%', height:'50px',marginRight:'3px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                                        <img src={messages_icon} style={{width:'20px',display:'block',margin:'auto'}} />
                                        <label style={{display:'block',padding:'5px 0px 5px 0px',fontSize:'xx-small'}}>Messagerie</label>
                                        <span style={{position:'absolute',top:'-5px',right:'-5px',backgroundColor:'blue',color:'white',borderRadius:'3px',marginRight:'3px',padding:'3px 5px 3px 5px'}}>{UserState.messages_counter}</span>
                                    </button>
                                    */
                                }
                                <button onClick={e=>{navigator('/user/orders/')}} style={{position:'relative',padding:'5px',marginRight:'3px',width:'18%',height:'50px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                                    <img src={orders_icon} style={{width:'20px',display:'block',margin:'auto'}} />
                                    <label style={{fontSize:AppState.settings.lang==='km'?'6':'x-small',display:'block',padding:'5px 0px 5px 0px'}}>{t('navigation.commandes')}</label>
                                    <span style={{position:'absolute',top:'-5px',right:'-5px',backgroundColor:'black',color:'white',borderRadius:'3px',padding:'3px 5px 3px 5px'}}>{UserState.orders_counter}</span>
                                </button>
                                {(UserState.is_staff) &&
                                <button onClick={e=>{navigator('/user/sales/')}} style={{position:'relative',padding:'5px',marginRight:'3px',width:'18%',height:'50px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                                    <img src={sales_icon} style={{width:'20px',display:'block',margin:'auto'}} />
                                    <label style={{fontSize:AppState.settings.lang==='km'?'6':'x-small',display:'block',padding:'5px 0px 5px 0px'}}>{t('navigation.ventes')}</label>
                                    <span style={{position:'absolute',top:'-5px',right:'-5px',backgroundColor:'red',color:'white',borderRadius:'3px',padding:'3px 5px 3px 5px'}}>{UserState.sales_counter}</span>
                                </button>
                                }
                                {(UserState.is_staff) &&
                                <button onClick={e=>{navigator('/user/sales/')}} style={{position:'relative',padding:'5px',marginRight:'3px',width:'18%',height:'50px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                                    <img src={money_icon} style={{width:'20px',display:'block',margin:'auto'}} />
                                    <label style={{fontSize:AppState.settings.lang==='km'?'xx-small':'x-small',display:'block',padding:'5px 0px 5px 0px'}}>{t('navigation.paiements')}</label>
                                    <span style={{position:'absolute',top:'-5px',right:'-5px',backgroundColor:'red',color:'white',borderRadius:'3px',padding:'3px 5px 3px 5px'}}>{UserState.sales_counter}</span>
                                </button>
                                }
                                <button onClick={e=>{navigator('/user/infos/')}} style={{position:'relative',padding:'5px',width:'18%',height:'50px',marginRight:'5px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                                    <img src={gift_icon} style={{width:'25px',display:'block',margin:'auto'}} />
                                    <label style={{fontSize:AppState.settings.lang==='km'?'xx-small':'x-small',display:'block',padding:'5px 0px 5px 0px'}}>{t('navigation.cadeaux')}</label>
                                    <span style={{zIndex:'99',position:'absolute',bottom:'-5px',right:'-10px',backgroundColor:'green',color:'white',borderRadius:'3px',padding:'3px 5px 3px 5px'}}>{UserState.gifts_sold+` ${AppState.settings.devise==='euro'? ' €':' KMF'}`}</span>
                                </button>
                                <button onClick={e=>{navigator('/user/infos/')}} style={{position:'relative',padding:'5px',width:'18%',height:'50px', fontSize:'xx-small',verticalAlign:'middle',borderRadius:'10px',border:'1px solid lightgray'}}>
                                    <img src={profil_icon} style={{width:'20px',display:'block',margin:'auto'}} />
                                    <label style={{fontSize:AppState.settings.lang==='km'?'xx-small':'x-small',display:'block',padding:'5px 0px 5px 0px'}}>{t('navigation.mon-compte')}</label>
                                </button>
                            </li>
                            <li style={{marginBottom:'5px',textAlign:'center',border:'none',borderRadius:'5px',paddingLeft:'0px'}} className="subControls-li">
                                <input onClick={e=>{navigator('/user/panier/')}} type="button" style={{verticalAlign:'middle',border:'none',borderRadius:'5px',padding:'10px',height:'45px',width:'90%',fontWeight:'bold',backgroundColor:'gold'}} value={t("navigation.valider-panier")} />
                            </li>
                            <li id="logout" style={{height:'30px',border:'1px solid lightgray',borderRadius:'5px',textAlign:'left',paddingLeft:'20px',flexDirection:(AppState.settings.lang==='ar')?'row-reverse':'row'}} onClick={e=>{LogOut();}} className="subControls-li">
                                <label style={{height:'100%',position:'relative',top:'7px'}}>{t('navigation.deconnexion')}</label>
                                <img src={logout_icon} style={{width:"25px",float:AppState.settings.lang=='ar'?'left':'right',marginRight:"10px"}}  />
                            </li>
                        </ul>
                    </fieldset>
                </div>
            );
        }
        else
        {
            return(
            <div className="SubControls" style={{width:"350px"}}>
                <fieldset id="SubControlsFieldSet" style={{width:'100%'}}>
                    <legend className="triangle"></legend>
                    {showpanier()}
                    <input onClick={e=>{navigator('/authentication/login/')}} style={{border:'1px solid lightgray', padding:'10px 10px 10px 10px',borderStyle:'none',borderRadius:'5px',backgroundColor:'#96F97B'}} type="button" value={t('navigation.connexion')} />
                    <input onClick={e=>{navigator('/authentication/registration/')}} style={{padding:'10px 10px 10px 10px',borderStyle:'none',borderRadius:'5px',marginTop:'5px',backgroundColor:'#87CEFA'}} type="button" value={t('navigation.inscription')} />
                </fieldset>
        </div>);
        }
    }
    
    const MobileUserMenu=({close})=>
    {
   
        const AdMenu=(close)=>
        {
            if(UserState.is_staff)
            {
                return(
                    <div>
                        <label className='menu-label' onClick={e=>{navigator("/user/sales/");close()}}>{t('user-menu.ventes')}
                            <div className="menu-icon">
                                <span className="menu-notification" style={{backgroundColor:'orangered'}}>
                                    {UserState.sales_counter}
                                </span>
                                <img style={{width:'25px',verticalAlign:'middle'}} src={chariotIcon} className="icon" />
                            </div>
                        </label>
                        <label className='menu-label' onClick={e=>{navigator("/user/partners/");close()}}>{t('user-menu.partenaires')}
                            <div className="menu-icon">
                                <img style={{width:'25px',verticalAlign:'middle'}} src={storeIcon} className="icon" />
                            </div>
                        </label>
                        <label className='menu-label' onClick={e=>{navigator("/user/payments/");close()}}>{t('user-menu.paiements')}
                            <div className="menu-icon">
                                <span className="menu-notification" style={{backgroundColor:'orangered'}}>
                                    {UserState.global_payments_counter}
                                </span>
                                <img style={{width:'25px',verticalAlign:'middle'}} src={cashIcon} className="icon" />
                            </div>
                        </label>
                        <label className='menu-label' onClick={e=>{navigator("/user/delivers/");close()}}>{t('user-menu.livreurs')}
                            {
                            /*
                            <div className="menu-icon">
                                <img style={{width:'25px',verticalAlign:'middle'}} src={deliveryIcon} className="icon" />
                            </div>
                            */
                            }
                        </label>
                        <label className='menu-label' onClick={e=>{navigator("/user/users/");close()}}>{t('user-menu.utilisateurs')}
                        {
                            /*
                            <div className="menu-icon">
                                <img style={{width:'25px',verticalAlign:'middle'}} src={deliveryIcon} className="icon" />
                            </div>
                                                        */
                        }
                        </label>
                    </div>);
            }
            else if(UserState.is_partner)
            {
                return(
                    <div>
                        <label className='menu-label' onClick={e=>{navigator("/user/sales/");close()}}>{t('navigation.colis')}
                            <div className="menu-icon">
                                <span className="menu-notification" style={{backgroundColor:'orangered'}}>
                                    {UserState.sales_counter}
                                </span>
                                <img style={{width:'25px',verticalAlign:'middle'}} src={ordersIcon} className="icon" />
                            </div>
                        </label>
                        <label className='menu-label' onClick={e=>{navigator("/user/payments/");close()}}>{t('navigation.mes_paiements')}
                            <div className="menu-icon">
                                <img style={{width:'25px',verticalAlign:'middle'}} src={cashIcon} className="icon" />
                            </div>
                        </label>
                        <label className='menu-label' onClick={e=>{navigator("/user/partner/myshop/");close()}}>{t('navigation.boutique')}
                            <div className="menu-icon">
                                <img style={{width:'25px',verticalAlign:'middle'}} src={storeIcon} className="icon" />
                            </div>
                        </label>
                    </div>);
            }
            else if(UserState.is_deliver)
            {
                return(
                    <div>
                        <label className='menu-label' onClick={e=>{navigator("/user/sales/");close()}}>{t('navigation.livraisons')}
                            <div className="menu-icon">
                                <img style={{width:'25px',verticalAlign:'middle'}} src="/images/icons/orders.webp" className="icon" />
                            </div>
                        </label>
                        <label className='menu-label' onClick={e=>{navigator("/user/payments/");close()}}>{t('navigation.mes_paiements')}
                            <div className="menu-icon">
                                <img style={{width:'25px',verticalAlign:'middle'}} src="/images/icons/paiements/cash.webp" className="icon" />
                            </div>
                        </label>
                        <label className='menu-label' onClick={e=>{navigator("/user/deliver/mydeliver/");close()}}>{t('navigation.enseigne')}
                            <div className="menu-icon">
                                <img style={{width:'25px',verticalAlign:'middle'}} src="/images/icons/store.webp" className="icon" />
                            </div>
                        </label>
                    </div>);
            }
        }
            
        const FormatText=(text)=>
            {
                if(text.length < 25)
                    return text;
                else
                    return text.substring(0,25)+'...';
        }

        const StandardMenu = ({close})=>
        {
            return(
                <div className="menu-content" style={{height:'100%',overflowY:'auto',overflowX:'hidden'}}>
                    <label className='menu-label' onClick={e=>{navigator('/user/infos/');close();}}>{t('user-menu.information')}</label>
                    <label className='menu-label' onClick={e=>{navigator('/user/orders/');close();}}>{t('user-menu.commandes')}
                        <div className="menu-icon">
                            <span className="menu-notification" style={{backgroundColor:'gray'}}>
                                {UserState.orders_counter}
                            </span>
                            <img style={{width:'20px',verticalAlign:'middle'}} src={historyIcon} className="icon" />
                        </div>
                    </label>
                    <label className='menu-label' onClick={e=>{navigator('/user/panier/');close();}}>{t('user-menu.panier')}
                        <div className="menu-icon">
                            <span className="menu-notification" style={{backgroundColor:'orangered'}}>
                                {UserState.panier.articles.length}
                            </span>
                            <img style={{width:'20px',verticalAlign:'middle'}} src={panierIcon} className="icon" />
                        </div>
                    </label>
                    <label className='menu-label' dir="rtl" onClick={e=>{navigator('/user/gifts/');close();}}>{t('navigation.cadeaux')}
                            <span dir="ltr" className="" style={{backgroundColor:'green',color:'white',padding:'2px 10px',marginRight:'10px',borderRadius:'4px'}}>
                                {UserState.gifts_sold+` ${AppState.settings.devise==='euro'? ' €':' KMF'}`}
                            </span>
                        <div className="menu-icon">
                            <img style={{width:'20px',verticalAlign:'middle'}} src={gift_icon} className="icon" />
                        </div>
                    </label>
                    {AdMenu(()=>{close();})}
                    <label className='menu-label' onClick={e=>{LogOut();close();}}>{t('user-menu.deconnexion')}
                        <div className="menu-icon">
                            <img style={{width:'20px',verticalAlign:'middle'}} src={logoutIcon} className="icon" />
                        </div>
                    </label>
                    <div>
                        {UserState.panier.articles.map((a)=>{
                            return(
                                <div style={{border:'1px solid lightgray',borderRadius:'5px',textAlign:'left',width:'90%',margin:'auto',marginTop:'5px',backgroundColor:'white',padding:'10px',position:'relative'}} className="subControls-li">
                                    <img src={MediaUrl(a.article.image)} style={{width:'50px', marginRight:'10px'}} />
                                    <div style={{display:'inline-block',verticalAlign:'top',maxWidth:'80%'}}>
                                        <label style={{padding:'0px',fontWeight:'bold',display:'block',color:'black',margin:'0px',fontSize:'small'}}>{FormatText(a.article.title)}</label>
                                        <span style={{color:'black',fontSize:'x-small',margin:'0px',marginRight:'20px'}}>Ref : {a.article.id}</span>
                                        <span style={{color:'black',fontSize:'x-small',margin:'0px',marginRight:'20px'}}>Qté : {a.quantity}</span>
                                    </div>
                                    <img src={removeIcon} style={{width:'20px',height:'20px',position:'absolute',bottom:'5px',right:'5px',wordWrap:'break-word'}} />
                                </div>);
                        })}
                    </div>  
            </div>);
        }
                
        return(
            <div id="User-Menu" style={{height:(screenHeight-80-50).toString()+'px'}}>
                {StandardMenu(close={close})}
            </div>);
                
    }

    const MobileBtnUser = ()=>
    {
        if(!UserState.auth)
        {
            return(
            <div className='btn-nav' style={{verticalAlign:'middle',display:'inline-block',height:'50px',width:'50px'}}>
                <img onClick={e=>{navigator('/authentication/');}} style={{width:'85%'}} src={panierIcon}  alt="navigation"/>
                <span id="notif" onClick={e=>{navigator('/authentication/');}}>
                    {UserState.panier.articles.length}
                </span>
            </div>);
        }
        else
        {
            return(
            <Popup trigger={
                <div className='btn-nav' style={{display:'inline-block',verticalAlign:'middle',height:'50px',width:'50px'}}>
                    <img   style={{width:'85%'}} src={panierIcon}  alt="navigation"/> 
                    <span id="notif" onClick={e=>{}}>
                        {UserState.panier.articles.length}
                    </span>
                </div>}>
                {close=>(
                        <div className='nav-pop-screen' style={{height:'100vh'}}>
                            <MobileUserMenu close={()=>{close();}} />  
                        </div>)}
            </Popup>);
        }
    }

    const ShowSearChBar=()=>
    {
        return(
            <div id="SearchBar">
                <MobileView>
                    <div id="SearchBarDiv" style={{display:'inline-block', verticalAlign:'middle'}}>
                        <input id="searchbarinput" placeholder={t('navigation.recherche')} type="search"  />
                        <img id="searchbarimg" src={searchBarIcon}/>      
                    </div>
                    <MobileBtnUser />
                </MobileView>
                <BrowserView>
                <div id="SearchBarDiv">
                    <input onChange={(e)=>{InputSearch.current = e.target.value}} id="searchbarinput" placeholder={t('navigation.recherche')} type="search"/>
                    <img onClick={(e)=>{
                        if(InputSearch.current==null || InputSearch.current=='')
                            return;
                        setVitrines({articles:[],filters:{searchitem:InputSearch.current},page:1});
                        }} id="searchbarimg" src={searchBarIcon}/>      
                </div>
                </BrowserView>
            </div>);
    }

    function BrowserNavControls()
    {
        return(
            <div id="Controls">
                    <ul id="Controls-ul">
                        {ShowSearChBar()}
                        <div style={{float:'right',width:'55%'}}>
                            {
                            <li onClick={e=>{}} className="Controls-li">
                                <div className="controls-li-div">
                                    <div>
                                        <img src={lang_icon} style={{width:"18px",verticalAlign:"middle",marginLeft:"5px"}}  />
                                    </div>
                                    <span className="labelname" onClick={e=>{}}>{t('navigation.devise-lang')}</span>
                                </div>
                                <div className="SubControls" style={{width:'300px'}}>
                                    <fieldset id="SubControlsFieldSet">
                                        <legend className="triangle"></legend>
                                        <div className="SubControls-ul">
                                            <SettingsMenu />
                                        </div>
                                    </fieldset>
                                </div>
                            </li>
                            }
                            <li className="Controls-li">
                                    <div className="controls-li-div">
                                        <div>
                                            <img src={apropos} style={{width:"18px",verticalAlign:"middle",marginLeft:"5px"}}  />
                                        </div>
                                        <span className="labelname" onClick={e=>{navigator('/about/');}}>{t('navigation.apropos')}</span>
                                    </div>
                            </li>
                            <Notifications />
                            <li className="Controls-li">
                            <div className="controls-li-div" onClick={e=>{if(!UserState.auth){navigator('/authentication/');}
                                }}>
                                    <div>
                                        <img src={panierIcon} style={{width:"18px",verticalAlign:"middle",marginLeft:"5px"}}  />
                                        <span style={{marginLeft:'-8px',Top:'-5px',fontSize:'small',backgroundColor:"rgb(255,0,0,0.8)",paddingLeft:"5px",paddingRight:"5px",borderRadius:'1px',verticalAlign:'top'}}>
                                            {UserState.panier.articles.length}</span>
                                    </div>
                                    <span className="labelname" >{UserState.auth ? UserState.labelname : t('navigation.espace-client')}</span>
                                </div>
                                {BrowserUserPanier()}
                            </li>
                        </div>
                    </ul>
                </div>
        );
    }
    
    return(
        <div id="Navigation" style={{width:'100%',zIndex:'99999'}}>
            <div id="Navigation-Container" style={{height:'100%'}}>
                <BrowserView>
                    <img onClick={e=>{navigator('/')}} id="Logo" src={logo}  alt="Logo"/>
                    <BrowserNavControls />
                </BrowserView>
                <MobileView>
                    <img onClick={e=>{navigator('/')}} id="Logo" src={logo}  alt="Logo"/>
                    <div style={{width:'95%',padding:'0px',height:'100%',float:'right'}}>
                        {ShowSearChBar()}
                    </div>                  
                </MobileView>           
            </div>
        </div>
    );
}